import React, { useContext } from 'react'

import {
    StyledTheWestHeader,
    StyledHeaderTimestamp,
    StyledChevronRight,
    StyledSubscribeLink,
    StyledSubscribeButton,
    StyledSubscribeIcon,
    StyledTimestampWrap,
    StyledTheWestHeaderWrapper,
    StyledMyNewsIcon,
} from 'component-library/content/TheWestHeader/TheWestHeader.styled'
import { InHouseLinks } from 'component-library/content/TheWestHeader/components/InHouseLinks'
import { CricketAnimation } from 'component-library/content/TheWestHeader/components/CricketAnimation'
import { useFeature } from 'common/feature-togglings/features'
import { EntitledToView } from 'component-library/user-registration/entitlements/EntitledToView'
import { RenderTargetContext } from 'common/context-providers/render-target-context'
import { MastHeadLogo } from './logos/MastheadLogo'
import { featurePublicationPageType } from 'thewest/routes/publication/kind/feature'
import { useTheme } from '@emotion/react'
import { AuthenticationProvider } from 'component-library/user-registration/authentication/AuthenticationProvider'
import { FeatureToggle } from 'component-library/feature-toggling/Toggle/Toggle'
import { createSubscribeLinkClickEvent } from 'component-library/user-registration/subscribe/createSubscribeClickLinkHandler'
import { InHouseLink } from 'component-library/navigation/TheWestMainNavigation/components/in_house_links/in_house_links'

export interface Props {
    className?: string
    inHouseLinks?: InHouseLink[]
    pageType?: string
    onEvent: (event: any) => void
}

export const TheWestHeader: React.FC<Props> = props => {
    const renderTarget = useContext(RenderTargetContext)
    const { section } = useTheme()
    const { className, inHouseLinks, onEvent } = props

    const cricketballEnabled = useFeature('cricketball') && section === 'default'

    const isRegionalSite = section !== 'default'

    const showDivider =
        (!cricketballEnabled && props.pageType === featurePublicationPageType) || isRegionalSite

    const subscribeButton = () =>
        renderTarget.renderTarget === 'static-error-page' ? null : (
            <AuthenticationProvider onEvent={onEvent}>
                {({ onSubscribeClick }) => (
                    <StyledSubscribeButton
                        onClick={() => {
                            createSubscribeLinkClickEvent('header', onEvent)()
                            onSubscribeClick()
                        }}
                        shouldShrink={cricketballEnabled}
                    >
                        <StyledSubscribeIcon />
                        Subscribe <StyledChevronRight />
                    </StyledSubscribeButton>
                )}
            </AuthenticationProvider>
        )
    return (
        <StyledTheWestHeaderWrapper>
            <StyledTheWestHeader showDivider={showDivider} className={className}>
                <FeatureToggle
                    feature="my-home"
                    on={() => (
                        <EntitledToView
                            isPremium={true}
                            entitled={() => (
                                <StyledSubscribeLink to={'/my-home'}>
                                    <StyledMyNewsIcon />
                                    My home <StyledChevronRight />
                                </StyledSubscribeLink>
                            )}
                            notEntitled={subscribeButton}
                        />
                    )}
                    off={subscribeButton}
                />
                <MastHeadLogo />
                <StyledTimestampWrap>
                    {inHouseLinks && <InHouseLinks items={inHouseLinks} />}
                    {renderTarget.renderTarget === 'static-error-page' ? null : (
                        <StyledHeaderTimestamp
                            className={className}
                            timestamp={Date.now()}
                            dateOnly={true}
                        />
                    )}
                </StyledTimestampWrap>
                {cricketballEnabled && <CricketAnimation />}
            </StyledTheWestHeader>
        </StyledTheWestHeaderWrapper>
    )
}
